export const supportEmail = 'support@ziaxen.com'

export const linkedInUrl = 'https://www.linkedin.com/company/ziaxen/'

export interface NavLink {
  label: string
  href: string
}

export const navLinks: NavLink[] = [
  { label: 'Platform', href: '#platform' },
  { label: 'Solutions', href: '#coverage' },
  { label: 'Compliance', href: '#compliance' },
  { label: 'Resources', href: '#platform' },
  { label: 'Company', href: '#compliance' },
]

export interface Capability {
  id: string
  title: string
  description: string
  metric: string
  metricLabel: string
}

export const capabilities: Capability[] = [
  {
    id: 'ids',
    title: 'In-vehicle intrusion detection',
    description:
      'Behavioural models sit on the CAN and Automotive Ethernet buses, flagging injected frames and spoofed ECU identities before they reach a safety-critical actuator.',
    metric: '<8ms',
    metricLabel: 'Detection to containment',
  },
  {
    id: 'ota',
    title: 'Signed OTA integrity',
    description:
      'Every firmware package is verified against its signing chain at the vehicle, so a compromised update pipeline cannot ship code to a moving fleet.',
    metric: '100%',
    metricLabel: 'Packages verified at the edge',
  },
  {
    id: 'soc',
    title: 'Fleet security operations',
    description:
      'A single console correlates events across every vehicle, ranks incidents by safety impact, and hands analysts the exact bus trace behind each alert.',
    metric: '2.1M',
    metricLabel: 'Vehicles under monitoring',
  },
]

export interface AttackSurface {
  id: string
  name: string
  summary: string
  status: 'Protected' | 'Monitored'
}

export const attackSurfaces: AttackSurface[] = [
  {
    id: 'perception',
    name: 'Perception stack',
    summary: 'Camera, LiDAR and radar inputs validated against sensor-spoofing signatures.',
    status: 'Protected',
  },
  {
    id: 'drive-by-wire',
    name: 'Drive-by-wire',
    summary: 'Steering, braking and throttle commands authenticated at the gateway.',
    status: 'Protected',
  },
  {
    id: 'v2x',
    name: 'V2X & telematics',
    summary: 'Certificate-backed messaging with rogue peer detection on every session.',
    status: 'Monitored',
  },
  {
    id: 'infotainment',
    name: 'Infotainment & apps',
    summary: 'Isolated from the vehicle bus, with process-level anomaly containment.',
    status: 'Monitored',
  },
]

export interface ComplianceItem {
  code: string
  title: string
  description: string
}

export const complianceItems: ComplianceItem[] = [
  {
    code: 'UN R155',
    title: 'Cybersecurity management system',
    description: 'Evidence, risk registers and incident reporting generated from live fleet data.',
  },
  {
    code: 'UN R156',
    title: 'Software update management',
    description: 'Auditable update provenance from build server through to installed vehicle.',
  },
  {
    code: 'ISO/SAE 21434',
    title: 'Road vehicle cybersecurity engineering',
    description: 'Threat analysis and risk assessment artefacts kept current across the lifecycle.',
  },
]
